// extracted by mini-css-extract-plugin
module.exports = {"region-title-container":"RegionTitle_region-title-container__7VV7J"};